import React from 'react';
import { Clock, MessageSquareX, Eye } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function ProblemSection() {
  return <section className="py-20 relative border-t border-white/5 bg-[#05070d]" data-id="element-215">
      {/* Subtle grid background */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgc3Ryb2tlPSIjZmZmZmZmIiBzdHJva2Utb3BhY2l0eT0iMC4wMyIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMCA0MGw0MC00ME0wIDBsNDAgNDAiLz48L2c+PC9zdmc+')] opacity-20" data-id="element-216" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-217">
        <FadeIn data-id="element-218">
          <div className="text-center mb-12" data-id="element-219">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-500/10 text-red-500 mb-6" data-id="element-220">
              <Clock className="w-8 h-8" data-id="element-221" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-222">
              Son las <span className="text-[#ff3366]" data-id="element-223">11:00 PM</span>.
            </h2>
          </div>
        </FadeIn>

        <div className="space-y-8 text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-224">
          <FadeIn delay={0.1} data-id="element-225">
            <p className="bg-white/5 p-6 rounded-lg border border-white/10 shadow-lg" data-id="element-226">
              Estás mirando la pantalla, revisando su{' '}
              <span className="text-[#00d9ff] font-semibold" data-id="element-227">"En línea"</span> y
              escribiendo un mensaje que vas a borrar por décima vez. Sientes
              ese nudo en el estómago porque sabes que si envías lo que sientes,
              solo vas a lograr que se aleje más.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-228">
            <div className="flex flex-col md:flex-row gap-6 items-center" data-id="element-229">
              <div className="flex-1" data-id="element-230">
                <p data-id="element-231">
                  El silencio de tu ex no es olvido,{' '}
                  <strong className="text-white" data-id="element-232">
                    es una posición de poder
                  </strong>
                  . Y mientras sigas actuando desde la desesperación, esa
                  persona seguirá teniendo el control total de tu felicidad.
                </p>
              </div>
              <div className="w-full md:w-1/3 flex justify-center" data-id="element-233">
                <div className="relative" data-id="element-234">
                  <div className="absolute inset-0 bg-[#ff3366]/20 blur-xl rounded-full" data-id="element-235" />
                  <MessageSquareX className="w-20 h-20 text-[#ff3366] relative z-10 opacity-80" data-id="element-236" />
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-237">
            <div className="text-center mt-12" data-id="element-238">
              <p className="text-2xl font-bold text-white border-b-2 border-[#00d9ff] inline-block pb-2" data-id="element-239">
                Es momento de hackear esa dinámica.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}